import { useState } from "react";
import api from "@/lib/api";

/**
 * Inline newsletter signup used in the site footer.
 * Single-opt-in — Resend sends a welcome + subsequent post announcements.
 */
export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!value) return;
    setStatus({ state: "loading", message: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: value });
      setStatus({ state: "success", message: data?.message || "You're on the list." });
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Something went wrong. Please try again.";
      const msg = Array.isArray(detail) ? "Please enter a valid email." : detail;
      setStatus({ state: "error", message: msg });
    }
  };

  if (status.state === "success") {
    return (
      <p data-testid="newsletter-success" className="text-sm text-[#C5A059] italic leading-relaxed">
        {status.message}
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-2" data-testid="newsletter-form">
      <div className="flex flex-col sm:flex-row gap-2">
        <label htmlFor="newsletter-email" className="sr-only">Email address</label>
        <input
          id="newsletter-email"
          data-testid="newsletter-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 border border-[#E5E5E5] bg-white px-3 py-2 text-sm text-[#1A1F24] placeholder:text-[#B8BCC2] focus:outline-none focus:border-[#C5A059]"
        />
        <button
          type="submit"
          disabled={status.state === "loading"}
          data-testid="newsletter-submit-btn"
          className="text-xs tracking-[0.22em] uppercase bg-[#1A1F24] text-white px-4 py-2 hover:bg-[#C5A059] transition-colors disabled:opacity-60"
        >
          {status.state === "loading" ? "…" : "Sign up"}
        </button>
      </div>
      {status.state === "error" && (
        <p className="text-xs text-red-600" data-testid="newsletter-error">{status.message}</p>
      )}
    </form>
  );
}
